import { getAPICallFeature } from '@micro-frontend-react/employee-experience/lib/UsageTelemetryHelper';
import {
  CustomProperties,
  IHttpClient,
  IHttpClientResult,
} from '@employee-experience/common/lib/Models';
import { SagaIterator } from 'redux-saga';
import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects';
import { ILetterTemplate } from '../../models/ILetterTemplate';
import { IRequestTemplatesAction, TemplateActionTypes } from '../action-types/templateActionTypes';
import { receiveTemplates, receiveTemplatesFailed } from '../actions/templateActions';

export function getSharedHttpConfig(url: string): CustomProperties {
  const resource = __EVL_API_RESOURCE_ID__;

  const httpConfig: CustomProperties = {
    url,
    resource,
  };

  return httpConfig;
}

//export const getProject = (state: any) => state;

export function* fetchLetterTemplates(action: IRequestTemplatesAction): SagaIterator {
  const { feature } = action;
  const httpClient: IHttpClient = yield getContext('httpClient');

  try {
    //const project = yield select(getProject);
    const response = yield call(
      [httpClient, httpClient.request],
      {
        ...getSharedHttpConfig(`${__EVL_API_BASE_URL__}api/v1.0/templates`),
        headers: {
          ImpersonatedCompanyCode:
            action?.impersonatedCompanyCode == null || action?.impersonatedCompanyCode == undefined
              ? ''
              : action.impersonatedCompanyCode,
          ImpersonatedCostCenter:
            action?.impersonatedCostCenter == null || action?.impersonatedCostCenter == undefined
              ? ''
              : action.impersonatedCostCenter,
        },
      },
      {},
      getAPICallFeature({ feature: 'EVL', subFeature: 'MetadataPanel' }, 'fetchLetterTemplates')
    );
    yield put(receiveTemplates(response.data.templates));
  } catch (exs) {
    const ex = exs as IHttpClientResult<ILetterTemplate[]>;
    yield put(receiveTemplatesFailed('something failed', ex?.status != 0 ? ex.status : 0));
  }
}

export function* letterTemplateSagas(): SagaIterator {
  yield all([takeLatest(TemplateActionTypes.REQUEST_TEMPLATES, fetchLetterTemplates)]);
}
